import * as React from 'react';
import App from 'components/_App';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { store } from 'Redux/Store';
import { Route } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import { I18nextProvider } from 'react-i18next';
import i18next from 'Translations/_i18n';
import 'Sass/output/style.css';
import {checkApplicationStatus, getApplicationStatus} from 'Modules/TechnicalBreak/Service/TechnicalBreak.Services'
import {ApplicationStatusResponse} from 'API/Info/info.Models'
import TechnicalBreakView from 'Modules/TechnicalBreak/View/TechnicalBreak.View'

export const history = createHistory();

interface State {
  applicationStatusData: null | ApplicationStatusResponse
}

export class RootApp extends React.Component<unknown, State> {
  public state: State = {
    applicationStatusData: null
  }

  public async componentDidMount() {
    const applicationStatusData = await getApplicationStatus()

    this.setState({
      applicationStatusData
    })
  }

  public render() {
    const { applicationStatusData } = this.state;

    if (checkApplicationStatus(applicationStatusData)) {
      return (
        <TechnicalBreakView
          title={applicationStatusData.topic}
          content={applicationStatusData.content}
          period={applicationStatusData.hours}
        />
      )
    }

    return (
      <I18nextProvider i18n={i18next}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Route path="/" component={App}/>
          </ConnectedRouter>
        </Provider>
      </I18nextProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/HelperFunctions/root.tsx